import { sum, concat } from '../utils/common';
export const MAX_NUMBER_OF_ITEMS_FROM_SERVER = 500;
export const MAX_NUMBER_OF_MODIFIER_GROUPS_FROM_SERVER = 100;
export const MAX_NUMBER_OF_MODIFIERS_FROM_SERVER = 200;
export const MAX_NUMBER_OF_PRICE_VARIANTS_FROM_SERVER = 100;
const BULK_CHUNK_SIZE = 100;
export const BULK_DELETE_CHUNK_SIZE = 75;
export const orderEntitiesById = (ids, entityArray) => {
  return ids.map(id => entityArray.find(entity => entity.id === id)).filter(entity => !!entity) || [];
};
export const settleApiCall = async callback => {
  try {
    const data = await callback();
    return {
      data,
      hasError: false
    };
  } catch (callError) {
    return {
      error: callError,
      hasError: true
    };
  }
};
export const getEntityChunks = (array, size) => {
  const result = array.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / size);
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [];
    }
    resultArray[chunkIndex].push(item);
    return resultArray;
  }, []);
  return result;
};
export const callInChunks = async function (callback, entities, chunkSize) {
  if (chunkSize === void 0) {
    chunkSize = BULK_CHUNK_SIZE;
  }
  const chunks = getEntityChunks(entities, chunkSize);
  const chunksResults = await Promise.all(chunks.map(async chunk => {
    return callback(chunk);
  }));
  const results = chunksResults.reduce((acc, result) => {
    var _acc$bulkActionMetada, _result$data$bulkActi;
    return {
      bulkActionMetadata: {
        totalFailures: sum((_acc$bulkActionMetada = acc.bulkActionMetadata) == null ? void 0 : _acc$bulkActionMetada.totalFailures, (_result$data$bulkActi = result.data.bulkActionMetadata) == null ? void 0 : _result$data$bulkActi.totalFailures)
      },
      results: concat(acc.results, result.data.results)
    };
  }, {});
  return results;
};
//# sourceMappingURL=utils.js.map